export default __webpack_public_path__ + "static/media/illustration_left.ae5bd688.png";